export function formatDate(iso: string | null | undefined, locale: string) {
  if (!iso) return "—";
  const d = new Date(iso);
  const tag = locale === "ar" ? "ar" : locale === "fr" ? "fr-FR" : "en-GB";
  return new Intl.DateTimeFormat(tag, {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "Africa/Lagos",
  }).format(d);
}

export function formatDateTime(iso: string, locale: string) {
  const d = new Date(iso);
  const tag = locale === "ar" ? "ar" : locale === "fr" ? "fr-FR" : "en-GB";
  return new Intl.DateTimeFormat(tag, {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Africa/Lagos",
  }).format(d);
}

/** Prefer Arabic DB fields when UI is Arabic; EN/FR fall back to English fields. */
export function pickLocalized<T extends Record<string, unknown>>(
  obj: T,
  locale: string,
  enKey: keyof T,
  arKey: keyof T,
): string {
  const v = locale === "ar" ? obj[arKey] : obj[enKey];
  return String(v ?? obj[enKey] ?? "");
}

export function paperLanguageLabel(
  language: string,
  t: { papers: { langEnglish: string; langArabic: string; langFrench: string } },
): string {
  const code = (language || "").toLowerCase();
  if (code === "ar") return t.papers.langArabic;
  if (code === "fr") return t.papers.langFrench;
  return t.papers.langEnglish;
}

export function paperStatusLabel(
  status: string,
  isPublic: boolean | null | undefined,
  t: {
    status: {
      submitted: string;
      under_review: string;
      minor_revision: string;
      major_revision: string;
      revised: string;
      accepted: string;
      rejected: string;
      published: string;
      publishedAccepted: string;
    };
  },
): string {
  if (status === "published" || (status === "accepted" && isPublic)) {
    return t.status.publishedAccepted;
  }
  if (status === "under_review") return t.status.under_review;
  if (status === "submitted") return t.status.submitted;
  if (status === "minor_revision") return t.status.minor_revision;
  if (status === "major_revision") return t.status.major_revision;
  if (status === "revised") return t.status.revised;
  if (status === "accepted") return t.status.accepted;
  if (status === "rejected") return t.status.rejected;
  if (status === "published") return t.status.published;
  return status;
}
